module.exports = __webpack_public_path__ + "static/media/how_et.8c5202ab.vtt";